import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { ProductImage } from '../ProductImage/ProductImage.js';

var VtoBanner = (_param)=>{
    var { onClick , vtoBanner  } = _param, productImageProps = swcHelpers.objectWithoutProperties(_param, [
        "onClick",
        "vtoBanner"
    ]);
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "vto-banner"
    }, /*#__PURE__*/ React.createElement(ProductImage, swcHelpers.extends({}, productImageProps), /*#__PURE__*/ React.createElement("div", {
        className: "vto-banner__overlay"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h4",
        variant: "smallest",
        className: "vto-banner__title"
    }, vtoBanner.title), (vtoBanner === null || vtoBanner === void 0 ? void 0 : vtoBanner.description) && /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        className: "vto-banner__sub"
    }, vtoBanner.description), /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('vto.callToAction'),
        "data-t": "vto-banner-button",
        variant: "outline",
        icon: "try-on",
        color: "primary",
        size: "small",
        className: "vto-banner__button",
        onClick: onClick
    }))));
};

export { VtoBanner, VtoBanner as default };
//# sourceMappingURL=VtoBanner.js.map
